export function Button({children, variant = 'solid', className = '', ...props}) {
    const baseStyles =
        'focus:outline-none focus:ring-2 focus:ring-offset-1 transition-colors duration-150';

    const variants = {
        solid: 'rounded-lg px-4 py-2 bg-button text-text-button hover:bg-hover focus:ring-black-500',
        productCard: 'bg-transparent text-text-blue font-black active:underline focus:ring-2 focus:ring-blue-400 px-2 py-1 mt-3',
        menu: 'rounded-lg px-4 py-2 font-semibold bg-button text-text-headerfooter hover:bg-hover focus:ring-black-500',
        ghost: 'rounded-md px-3 py-1.5 font-medium bg-transparent text-text-button hover:bg-white hover:text-primary focus:ring-white',
        danger: 'rounded-lg px-4 py-2 font-medium bg-buttonred text-text-button hover:bg-buttonred/70 focus:ring-red-500',
        outline: 'rounded-md px-4 py-2 font-medium border border-gray-300 text-text-buttonghost hover:bg-gray-50',
        rating: 'w-15 px-2 py-1 rounded-md border border-checkout-bg text-text-buttonghost hover:bg-gray-50',
    };

    const styles = `${baseStyles} ${variants[variant] || variants.solid} ${className}`;

    return (
        <button className={styles} {...props}>
            {children}
        </button>
    );
}
